import { css } from '@emotion/react';

export const fontFaces = css`
  @font-face {
    font-family: 'FuturaStd';
    src: url('/assets/fonts/FuturaStd-Bold.woff2') format('woff2'),
      url('/assets/fonts/FuturaStd-Bold.woff') format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'FuturaStd';
    src: url('/assets/fonts/FuturaStd-Book.woff2') format('woff2'),
      url('/assets/fonts/FuturaStd-Book.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'FuturaStd';
    src: url('/assets/fonts/FuturaStd-Heavy.woff2') format('woff2'),
      url('/assets/fonts/FuturaStd-Heavy.woff') format('woff');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'FuturaStd';
    src: url('/assets/fonts/FuturaStd-Light.woff2') format('woff2'),
      url('/assets/fonts/FuturaStd-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'FuturaStd';
    src: url('/assets/fonts/FuturaStd-Medium.woff2') format('woff2'),
      url('/assets/fonts/FuturaStd-Medium.woff') format('woff');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/fonts.ts